interface HomePageProps {
  hasUsers: boolean;
  hasActiveUser: boolean;
  authenticated: boolean;
  onStart: () => void;
  onLogin: () => void;
  onLogout: () => void;
  onPrivacy: () => void;
}

export default function HomePage({
  hasUsers,
  hasActiveUser,
  authenticated,
  onStart,
  onLogin,
  onLogout,
  onPrivacy,
}: HomePageProps) {
  const canContinue = hasActiveUser;

  return (
    <div className="mx-auto flex w-full max-w-lg flex-col items-center gap-8 py-12 text-center">
      <header>
        <h1 className="text-4xl font-semibold tracking-tight text-strong">
          TouchType
        </h1>
        <p className="mt-3 text-muted">
          Ti-fingersystemet · øv dansk touchtyping
        </p>
        <p className="mt-2 text-sm text-faint">
          Lær blindskrift trin for trin — med fokus på præcision, ikke fart.
        </p>
      </header>

      <div className="flex w-full flex-col gap-3">
        <button type="button" onClick={onStart} className="btn-primary w-full py-3 text-base">
          {canContinue ? 'Fortsæt' : hasUsers ? 'Vælg bruger' : 'Kom i gang'}
        </button>
        {!authenticated && (
          <button type="button" onClick={onLogin} className="btn-secondary w-full py-3">
            Log ind / opret konto
          </button>
        )}
      </div>

      {!canContinue && (
        <section className="surface w-full space-y-4 p-5 text-left">
          <div>
            <h2 className="label">Gratis i browseren</h2>
            <p className="mt-1 text-sm text-muted">
              Ingen installation — virker på computer, tablet og Chromebook.
              Opret en valgfri konto for at gemme fremgang på tværs af enheder.
            </p>
          </div>
          <div>
            <h2 className="label">Dansk fra start til slut</h2>
            <p className="mt-1 text-sm text-muted">
              Mac- og PC-dansk tastatur med æ, ø og å. Struktureret forløb fra
              hjemmerækken til hele alfabetet, tegn og længere tekster.
            </p>
          </div>
          <div>
            <h2 className="label">For elever og voksne</h2>
            <p className="mt-1 text-sm text-muted">
              Velegnet til folkeskole, hjemmeøvelse og voksne der vil lære at
              skrive uden at kigge på tasterne — i et roligt tempo uden
              fartpres.
            </p>
          </div>
        </section>
      )}

      <div className="flex flex-wrap items-center justify-center gap-3 text-sm">
        {authenticated && (
          <button type="button" onClick={onLogout} className="btn-ghost">
            Log ud
          </button>
        )}
        <button type="button" onClick={onPrivacy} className="text-faint hover:text-strong">
          Privatliv og vilkår
        </button>
      </div>
    </div>
  );
}
